import Vue from 'vue'
import Vuex from 'vuex'
import store from './modules/store'
import auth from './modules/auth'
import savedAddresses from './modules/savedAddresses'
import orderStatuses from './modules/orderStatuses'
import order from './modules/order'
import catalog from './modules/catalog'
import settings from './modules/settings'
import ui from './modules/ui'
import extensions from './modules/extensions'
import offers from './modules/offers'
import recaptcha from './modules/recaptcha'
import broadcast from './modules/broadcast'
import notifications from './modules/notifications'
import articles from './modules/articles'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    store,
    auth,
    savedAddresses,
    orderStatuses,
    order,
    catalog,
    settings,
    ui,
    extensions,
    offers,
    recaptcha,
    broadcast,
    notifications,
    articles,
  },
})
